"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLayoutBlock = mapLayoutBlock;
exports.mapLayout = mapLayout;
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const sylex_1 = require("@leshen/gatsby-theme-leshen/sylex");
const mapBlocks_1 = require("./mapBlocks");
const mapToBannerProps_1 = __importDefault(require("./props/mapToBannerProps"));
const mapToBillboardProps_1 = __importDefault(require("./props/mapToBillboardProps"));
const mapToCtaBarProps_1 = __importDefault(require("./props/mapToCtaBarProps"));
const mapToHeroProps_1 = __importDefault(require("./props/mapToHeroProps"));
const mapToItemBankProps_1 = __importDefault(require("./props/mapToItemBankProps"));
const mapToMegaFormProps_1 = __importDefault(require("./props/mapToMegaFormProps"));
const mapToSectionProps_1 = __importDefault(require("./props/mapToSectionProps"));
const mapToSplitBillboardProps_1 = __importDefault(require("./props/mapToSplitBillboardProps"));
const mapToSplitContentProps_1 = __importDefault(require("./props/mapToSplitContentProps"));
const mapToSplitModuleProps_1 = __importDefault(require("./props/mapToSplitModuleProps"));
const mapToResourcesProps_1 = __importDefault(require("./props/mapToResourcesProps"));
const COMPONENT_MAP = {
    section: {
        Component: gatsby_theme_leshen_1.VariableContent,
        formatProps: mapToSectionProps_1.default,
    },
    splitContent: {
        Component: gatsby_theme_leshen_1.SplitContent,
        formatProps: mapToSplitContentProps_1.default,
    },
    splitBillboard: {
        Component: gatsby_theme_leshen_1.Billboard,
        formatProps: mapToSplitBillboardProps_1.default,
    },
    billboard: {
        Component: gatsby_theme_leshen_1.Billboard,
        formatProps: mapToBillboardProps_1.default,
    },
    banner: {
        Component: gatsby_theme_leshen_1.Banner,
        formatProps: mapToBannerProps_1.default,
    },
    hero: {
        Component: gatsby_theme_leshen_1.Hero,
        formatProps: mapToHeroProps_1.default,
    },
    splitModule: {
        Component: gatsby_theme_leshen_1.SplitModule,
        formatProps: mapToSplitModuleProps_1.default,
    },
    ctaBar: {
        Component: gatsby_theme_leshen_1.CtaBar,
        formatProps: mapToCtaBarProps_1.default,
    },
    itemBankBlock: {
        Component: gatsby_theme_leshen_1.ItemBank,
        formatProps: mapToItemBankProps_1.default,
    },
    megaForm: {
        Component: sylex_1.SylexMegaForm,
        formatProps: mapToMegaFormProps_1.default,
    },
    resources: {
        Component: gatsby_theme_leshen_1.Resources,
        formatProps: mapToResourcesProps_1.default,
    },
};
function mapLayoutBlock({ block, mappers, inHero = false, isSpanish = false, packages = {}, forms = {}, title, publishDate, author }) {
    const key = block.blockType;
    const { Component, formatProps } = COMPONENT_MAP[key] || {};
    if (!Component || !formatProps) {
        console.warn(`No component found for section type: ${block.blockType}`);
        return null;
    }
    /** Set Default Stack Alignment to Center */
    let alignMainContent = 'Center';
    if (block?.blockType === 'section' && block.alignMainContent) {
        alignMainContent = block?.alignMainContent;
    }
    const jumpLinkId = 'jumpLinkId' in block && typeof block.jumpLinkId === 'string'
        ? block.jumpLinkId
        : null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [jumpLinkId && (0, jsx_runtime_1.jsx)("div", { id: jumpLinkId }), (0, react_1.createElement)(Component, { ...formatProps({
                    author: author,
                    data: block,
                    mappers,
                    inHero,
                    forms,
                    packages,
                    sectionKey: block?.id || '',
                    title,
                    publishDate,
                }), key: block?.id }, 'modules' in block && (block.modules ?? []).length > 0 && ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Stack, { alignMainContent: alignMainContent, children: (0, mapBlocks_1.mapBlocks)({
                    mappers,
                    inHero,
                    blocks: block.modules || [],
                    spanish: isSpanish,
                    packages,
                    forms,
                    sectionKey: block?.id || '',
                }) })))] }));
}
function mapLayout({ layout, mappers, isSpanish = false, packages = {}, forms = {}, title, publishDate, author }) {
    return layout.map((block, index) => {
        const inHero = index === 0;
        return mapLayoutBlock({
            author: inHero ? author : undefined,
            block,
            mappers,
            inHero,
            isSpanish,
            packages,
            forms,
            title,
            sectionKey: block?.id || '',
            publishDate
        });
    });
}
